import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function YearCard({ year, items }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border rounded-xl overflow-hidden bg-white">
      <button onClick={() => setOpen(v => !v)} className="w-full flex items-center justify-between px-4 py-3 text-left font-semibold">
        <span>Année scolaire: {year}</span>
        <span className={`transition ${open ? "rotate-180" : ""}`}>▾</span>
      </button>
      {open && (
        <div className="px-4 pb-4 text-slate-700 space-y-3">
          {items && items.length > 0 ? (
            items.map((it, idx) => (
              <div key={idx} className="bg-orange-50 border border-orange-100 rounded-lg p-3">
                {it.title && <h4 className="font-semibold text-slate-900">{it.title}</h4>}
                {it.body && (
                  <pre className="whitespace-pre-wrap text-sm mt-1">{it.body}</pre>
                )}
              </div>
            ))
          ) : (
            <p className="text-sm text-slate-500">Aucun article détaillé importé pour cette année.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default function Articles() {
  const [data, setData] = useState({ years: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const r = await axios.get(`${API}/articles`);
        setData(r.data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Failed loading articles", e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">Articles</h1>
      {loading ? (
        <p className="mt-6 text-slate-600">Chargement…</p>
      ) : (
        <div className="mt-6 grid gap-3">
          {data.years.map((y) => (
            <YearCard key={y.year} year={y.year} items={y.items} />
          ))}
        </div>
      )}
    </main>
  );
}